import { render, staticRenderFns } from "./OwnerFieldReadonly.vue?vue&type=template&id=4bc0435e&scoped=true&"
import script from "./OwnerFieldReadonly.vue?vue&type=script&lang=js&"
export * from "./OwnerFieldReadonly.vue?vue&type=script&lang=js&"
import style0 from "./OwnerFieldReadonly.vue?vue&type=style&index=0&id=4bc0435e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0435e",
  null
  
)

export default component.exports